import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/', redirect: '/home'
  },
  {
    path: '/home', component: () => import('../components/Home.vue')
  },
  {
    path: '/equip&tech', component: () => import('../components/Technology.vue')

  },

  {
    path: '/news', component: () => import('../components/News.vue')
  },
  {
    path: '/aboutus', component: () => import('../components/Aboutus.vue')
  },
  {
    path: '/cases', component: () => import('../components/cases/Cases.vue'), redirect: '/cases/part1',
    children: [
      {
        path: '/cases/part1', component: () => import('../components/cases/Cases_part1.vue'),
        name:'Cases_part1'
      },
      {
        path: '/cases/part2', component: () => import('../components/cases/Cases_part2.vue'),
        name:'Cases_part2'
      },
      { path: '/cases/detail', component: () => import('../components/cases/Cases-detail.vue') }
    ]
  },
  {
    path: '/contactus', component: () => import('../components/Contactus.vue')
  },
    // 理念
    // 宗旨
    // 原则
    // 愿景
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
